/**
 * 销售数据概览数据管理
 */
import api from '../../api/api'
import * as types from '../mutation'
import { getNowTime } from '../../utils/com'

const state = {
    statsdata: {},
    statstotal: 0,
    newstats: {},
    newstatstotal: 0,
    eventdata: {},
    eventtotal: 0,
    apidata: null,
    appidlist: null,
    apitotal: null,
    labellist: null,
    labeltotal: null,
}

const getters = {
    statsdata: state => state.statsdata,
    statstotal: state => state.statstotal,
    newstats: state => state.newstats,
    newstatstotal: state => state.newstatstotal,
    eventdata: state => state.eventdata,
    eventtotal: state => state.eventtotal,
    apidata: state => state.apidata,
    appidlist: state => state.appidlist,
    apitotal: state => state.apitotal,
    labellist: state => state.labellist,
    labeltotal: state => state.labeltotal,
}

 const actions = {
    /**
     * 获取销售数据概览数据
     */
    getConsoleNews ({ commit, state, rootState }, param) {
        console.debug("getConsoleNews> param:%o", param);
        commit(types.GET_CONSOLE_NEWS_LIST, {})
        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/console/news',
            param,
            (response) => {
                console.debug("getConsoleNews ok response:%o", response);
                commit(types.GET_CONSOLE_NEWS_LIST, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("getConsoleNews err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });
    },

    updateConsoleNewsDone({ commit }, param) {
        console.debug("updateConsoleNewsDone> param:%o", param);
        commit(types.ADD_CONSOLE_DATA_DONE, { param })
    },

    /**
     *    获取新闻统计数据
     */
    getNewStatis ({ commit, state, rootState }, param) {
        console.debug("getNewStatis> param:%o", param);
        commit(types.GET_NEWS_STATIS_LIST, {})
        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/news/statistics',
            param,
            (response) => {
                console.debug("getNewStatis ok response:%o", response);
                commit(types.GET_NEWS_STATIS_LIST, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("getNewStatis err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });
    },
    /**
     *    获取状态变化数据
     */
    getConsoleEvent ({ commit, state, rootState }, param) {
        console.debug("getConsoleEvent> param:%o", param);
        commit(types.GET_CONSOLE_EVENT_LIST, {})
        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/console/event',
            param,
            (response) => {
                console.debug("getConsoleEvent ok response:%o", response);
                commit(types.GET_CONSOLE_EVENT_LIST, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("getConsoleEvent err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });
    },

    /**
     *    获取状态变化数据
     */
    getConsoleApi ({ commit, state, rootState }, param) {
        console.debug("getConsoleApi> param:%o", param);
        commit(types.GET_CONSOLE_API_LIST, {})
        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/console/api',
            param,
            (response) => {
                console.debug("getConsoleApi ok response:%o", response);
                commit(types.GET_CONSOLE_API_LIST, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("getConsoleApi err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });
    },

    /**
     *    获取状态变化数据
     */
    getLabelList ({ commit, state, rootState }, param) {
        console.debug("getLabelList> param:%o", param);
        commit(types.GET_LABELS_LIST, {})
        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/label/list',
            param,
            (response) => {
                console.debug("getLabelList ok response:%o", response);
                commit(types.GET_LABELS_LIST, { response })
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("getLabelList err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });
    },

    updateLabel ({ commit, state, rootState }, param) {
        console.debug("updateLabel> param:%o", param);
        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/label/update',
            param,
            (response) => {
                console.debug("updateLabel ok response:%o", response);
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("updateLabel err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });
    },

    delLabel ({ commit, state, rootState }, param) {
        console.debug("delLabel> param:%o", param);
        return new Promise((resolve, reject) => {
          api.apiCommunication(
            '/api/label/del',
            param,
            (response) => {
                console.debug("delLabel ok response:%o", response);
                if(typeof(resolve) === 'function'){
                    resolve(response)
                }
            },
            (err) => {
                console.error("delLabel err:%o", err);
                if(typeof(reject) === 'function'){
                    reject(err)
                }
            })
        });
    }



}

const mutations = {
    [types.GET_CONSOLE_NEWS_LIST] (state, { response }) {
        console.debug("GET_CONSOLE_NEWS_LIST> response:%o", response);
        let _data = {}
        if(response && response.code === 0){
            _data = response.data.news
            state.statstotal = Number(response.data.total)
        }
        state.statsdata = _data
    },

    [types.GET_NEWS_STATIS_LIST] (state, { response }) {
        console.debug("GET_NEWS_STATIS_LIST> response:%o", response);
        let _data = {}
        if(response && response.code === 0){
            _data = response.data
            state.newstatstotal = Number(response.data.total)
        }
        state.newstats = _data
    },

    [types.ADD_CONSOLE_DATA_DONE](state, { param }) {
        console.debug("ADD_CONSOLE_DATA_DONE> param:%o", param);
        if (param && param.id && param.done) {
              state.statsdata.filter(u => {
                if (u.id === param.id) {
                  u.done = param.done;
                  return true;
                }
              });
        }
    },

    [types.GET_CONSOLE_EVENT_LIST] (state, { response }) {
        console.debug("GET_CONSOLE_EVENT_LIST> response:%o", response);
        let _data = {}
        if(response && response.code === 0){
            _data = response.data.events
            state.eventtotal = Number(response.data.total)
        }
        state.eventdata = _data
    },

    [types.GET_CONSOLE_API_LIST] (state, { response }) {
        console.debug("GET_CONSOLE_API_LIST> response:%o", response);
        let _apidata = {}, _appidlist=[]
        if(response && response.code === 0){
            _apidata = response.data.statistics
            _appidlist = response.data.appidlist
            state.apitotal = Number(response.data.total)
        }
        state.apidata = _apidata
        state.appidlist = _appidlist
    },

    [types.GET_LABELS_LIST](state, { response }) {
        console.debug("GET_LABELS_LIST> response:%o", response);
        let _labellist = []
        if(response && response.code === 0){
            _labellist = response.data.label
            state.labeltotal = Number(response.data.total)
        }
        state.labellist = _labellist
    },

}

export default{
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/stats.js